import { render, staticRenderFns } from "./hotels-list.vue?vue&type=template&id=3dacd8b4&"
import script from "./hotels-list.vue?vue&type=script&lang=js&"
export * from "./hotels-list.vue?vue&type=script&lang=js&"
import style0 from "./hotels-list.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports